module.exports = __webpack_public_path__ + "img/01-sm.d46a006.webp";